import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickDirective } from './click.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ClickDirective
  ],
  exports: [
    ClickDirective
  ]
})
export class ClickModule { }
